import React, { useRef, useCallback, useEffect, useState } from 'react';
import { UploadProjectData } from './UploadProjectData';
import { ProjectThunk } from '../../../../../../store/thunk/project.thunk';
import { useDispatch } from 'react-redux';
import {useActiveProjectSelector, useProjectUploadSelector} from '../../../../../../store/selectors/project.selectors';
import { useTypedSelector } from '../../../../../../store/selectors/selectors.utils';
// import { CalendarModel } from '../../../../../../models/responses/calendar.model';
// import { Omit } from 'redux-form';
import * as projectActions from '../../../../../../store/actions/project.actions';
// import { FirebaseProjectFunctions } from '../../../../../../firebase/firebase-functions/project-service';
import { useNavigate } from "react-router-dom";
import RouteNameConstants from "../../../../../../constants/route-name.constants";
import NavBarUploadModal from "../NavigationBarModals/NavBarUploadModal";
// import store from '../../../../../../store/store';

interface InjectProps {
  open: boolean;
  onClose: () => void;
  title: string;
  //handleInput: () => void;
  uploadStrategy?: boolean;
  setUploadStrategyModalOpen: (value: boolean) => void;
}

type PropsType = InjectProps;

export const UploadProjectDataModal: React.FC<PropsType> = (props) => {
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [showUploadModal, setShowUploadModal] = useState<any>(null);
  const uploadingError = useTypedSelector(
    (state) => state.project.uploadingError
  );
  const isMountedRef = useRef(false);

  const uploads = useProjectUploadSelector();
  
  useEffect(() => {
    isMountedRef.current = true;
    if (isMountedRef.current) {
      setErrorMessage(uploadingError || '');
    }
    return () => {
      isMountedRef.current = false;
    };
  }, [uploadingError]);


  const activeUpload = showUploadModal ? uploads.find((upload) => upload.uploadId === showUploadModal) : null;

  return activeUpload ? (
      <NavBarUploadModal upload={activeUpload} setShowUploadModal={setShowUploadModal} />) :
      (
          <UploadProjectData
      {...props}
      errorMessage={errorMessage}
      multiFile={!props.uploadStrategy}
      setErrorMessage={setErrorMessage}
      isUpdate = {props.uploadStrategy ? true : false}
      setShowUploadModal={setShowUploadModal}
    />
  );
};
